import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthDataCommonState, selectLanguageInCommonState } from 'app/app-state.index';
import { BaseForm } from 'app/core/components/base-form';
import { SimpleBaseForm } from 'app/core/components/simple-base-form';
import { WebRouletteStatus } from 'app/core/model/web-roulette-status';
import { SideBarService } from 'app/core/services/side-bar.service';
import { LoginService } from 'app/login/services/login.service';
import { Roulette } from 'app/public/model/roulette.model';
import { SaveRouletteRequest } from 'app/public/model/save-roulette-request.model';
import { CouponValidationService } from 'app/public/services/coupon-validation.service';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FormMode, ResolutionType } from 'app/shared/model/enums';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable, of, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-roulette',
  templateUrl: './roulette.component.html',
  styleUrls: ['./roulette.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteComponent extends BaseForm implements OnInit {

  @ViewChild("form") _ngForm: NgForm;
  currentLanguage;
  roulette: Roulette;
  statusWarning: string;
  changePackageButtonText: string;
  displaySettings = AppResolutionType == ResolutionType.Desktop ? true : false;


  _loginSelect: Subscription;
  returnUrl: string;
  AppResolutionType = AppResolutionType;
  ResolutionType = ResolutionType;
  WebRouletteStatus = WebRouletteStatus;

  constructor(
    sideBarService: SideBarService,
    cdr: ChangeDetectorRef,
    messageService: AdvMessageService,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    private webRouletteService: WebRouletteService,
    router: Router, private authService: AppAuthService, private loginService: LoginService,
    private store: Store<AppState>, private commonService: CommonService,
    private couponValidationService: CouponValidationService,
  ) {
    super(messageService, localizationService, route, sideBarService, cdr, router)
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLanguage = language;
    }));
  }

  protected get form(): NgForm {
    return this._ngForm;
  }
  protected createNew() {
    return this.webRouletteService.getDefaultRoulette(this.currentLanguage).pipe(tap(roulette => {
      this.roulette = roulette;
      this.markAsDirty();
    }));
  }

  public saveAndPublish() {
    if (this.couponValidationService.currentState) {
  this.messageService.errorMessage (this.localizationService.Translate('ERROR_MESSAGES.ERROR_CUPON_LINK'));
  return;
    }
    if (this.isDirty()) {
      this.saveForm(true);
    } else {
      this.returnUrl = `/webplatform/roulette/${this.id}`
       this.router.navigate(['webplatform', 'roulette-subscribtion', this.id, { returnUrl: this.returnUrl }]);
    }
  }
  public save(publishRoulette = false): Observable<any> {
    if (this.couponValidationService.currentState) {
  this.messageService.errorMessage (this.localizationService.Translate('ERROR_MESSAGES.ERROR_CUPON_LINK'));
  return;
    }
    if (!this.authService.isLoggedOn) {
      this.loginBeforeSaveRoulette(publishRoulette);
    } else if (publishRoulette) {
      this.doSaving().subscribe(savedRouletteId => {
        this.messageService.successMessage('GENERAL.MESSAGES.SAVED_SUCCESSFULY', true);
        this.cdr.markForCheck();
        setTimeout(() => {
          this.returnUrl = `/webplatform/roulette/${savedRouletteId}`
          this.router.navigate(['webplatform', 'roulette-subscribtion', savedRouletteId, { returnUrl: this.returnUrl }]);
        }, 1);
      })
    }
    else {
      return this.doSaving();
    }
  }

  private loginBeforeSaveRoulette(publishRoulette: boolean) {
    if (this._loginSelect) {
      this._loginSelect.unsubscribe();
    }
    this.store.select(selectAuthDataCommonState).subscribe(authData => {
      if (this.authService.isLoggedOn) {
        if (this._loginSelect) {
          this._loginSelect.unsubscribe();
        }
        if (this.formMode == FormMode.New && this.isDirty()) {
          this.saveForm(publishRoulette);
        }
      }
    })
    this.loginService.showLoginDialog(this.cdr);
  }

  private doSaving(): Observable<any> {
    this.commonService.blockScreen(true);
    const request = this.createSaveRequest();
    switch (this.formMode) {
      case FormMode.New:
        return this.webRouletteService.saveNewRoulette(request).pipe(
          tap(() => {
            this.commonService.blockScreen(false);
            this.cdr.markForCheck();
          })
        );
      case FormMode.Edit:
        return this.webRouletteService.saveRoulette(this.id, request).pipe(
          map(r => this.id),
          tap(() => {
            this.commonService.blockScreen(false);
            this.cdr.markForCheck();
          })
        );
      default:
        throw new Error(`save is not supported in ${this.formMode} mode}`);
    }
  }

  saveCompleted() {
    this.fitNavigationByLoginState();
  }
  protected loadData(): Observable<any> {
    return this.webRouletteService.getRoulette(this.id).pipe(tap(roulette => {
      if (roulette == null) { this.router.navigate(['webplatform', 'roulette']); }
      else {
        this.roulette = roulette;
        this.setStatusWarning();
      }
    }));
  }

  createSaveRequest(): SaveRouletteRequest {
    return {
      Id: this.roulette.GeneralDetails.Id,
      DesignId: this.roulette.Design.DesignId,
      SpinnerId: this.roulette.Design.IsCustomSpinner ? null : this.roulette.Design.Spinner.Id,
      IsCustomSpinner: this.roulette.Design.IsCustomSpinner || false,
      CustomDarkColor: this.roulette.Design.IsCustomSpinner ? this.roulette.Design.CustomDarkColor : null,
      CustomLightColor: this.roulette.Design.IsCustomSpinner ? this.roulette.Design.CustomLightColor : null,
      CustomBackgroundImageUrl: this.roulette.Design.IsCustomSpinner ? this.roulette.Design.CustomBackgroundImageUrl : null,
      NewCustomBackgroundImageAsBase64: this.roulette.Design.IsCustomSpinner ? this.roulette.Design.newCustomBackgroundImageAsBase64 : null,
      CustomButtonUrl: this.roulette.Design.IsCustomSpinner ? this.roulette.Design.CustomButtonUrl : null,
      Name: this.roulette.GeneralDetails.Name,
      Comment: this.roulette.GeneralDetails.Comment,
      ExpireDays: this.roulette.GeneralDetails.ExpireDays,
      AutoRenewalPackage: this.roulette.GeneralDetails.AutoRenewalPackage,
      LogoSettings: { ...this.roulette.Design.LogoSettings },
      Coupons: this.roulette.Coupons,
      AdditionalCustomerFields: this.roulette.AdditionalCustomerFields,
      SendCouponBy: this.roulette.SendCouponBy,
    };
  }

  fitNavigationByLoginState() {
    if (this.authService.isLoggedOn) {
      if (this.id) {
        this.router.navigate(['webplatform', 'roulette', this.id]);
      } else {
        this.router.navigate(['webplatform', 'roulette']);
      }
    }
  }


  setStatusWarning() {
    let description;
    switch (this.roulette.GeneralDetails.Status) {
      case WebRouletteStatus.expired:
        description = this.localizationService.Translate('ROULETTE.EXPIRE_MSG');
        break;
      case WebRouletteStatus.purchedNotLimitPackage:
      case WebRouletteStatus.notPurched:
        break;
      case WebRouletteStatus.purchedButNotAvailable:
        description = this.localizationService.Translate('ROULETTE.NOT_AVAILABLE_MSG');
        break;
      case WebRouletteStatus.spinsLimit:
      case WebRouletteStatus.spinsLimitForFreePackage:
        description = this.localizationService.Translate('ROULETTE.SPINS_LIMIT_MSG');
        break;
      case WebRouletteStatus.purched:
      case WebRouletteStatus.purchedFreePackage:
        const maxRemainingDaysForDisplayMessage = 7;
        const minUsedPercentageForDisplayWarning = 70;
        let remainingDays;
        if (this.roulette.GeneralDetails.EndDate) {
          let diffTime = this.roulette.GeneralDetails.EndDate.getTime() - (new Date()).getTime();
          diffTime /= 1000 * 60 * 60 * 24;//get diff in days
          remainingDays = Math.ceil(diffTime);//round to up
        }

        const allowSpinsCount = this.roulette.GeneralDetails.SpinsCountInPackage ? this.roulette.GeneralDetails.SpinsCountInPackage : 0;
        const usedSpinsCount = this.roulette.GeneralDetails.ActualSpinsCount ? this.roulette.GeneralDetails.ActualSpinsCount : 0;

        if (usedSpinsCount * 100 / allowSpinsCount >= minUsedPercentageForDisplayWarning
          || remainingDays <= maxRemainingDaysForDisplayMessage) {
          if (this.roulette.GeneralDetails.EndDate) {
            description = this.localizationService.Translate('ROULETTE.SOON_EXPIRE_MSG', { remainingSpins: allowSpinsCount - usedSpinsCount, remainingDays });
          } else {
            description = this.localizationService.Translate('ROULETTE.SOON_EXPIRE_MSG_WITHOUT_DAYS', { remainingSpins: allowSpinsCount - usedSpinsCount });

          }
        }
        break;

    }
    this.statusWarning = description;

    if (this.statusWarning) {
      const changeTextTranslateKey = this.webRouletteService.getChangePackageText(this.roulette.GeneralDetails.Status, this.roulette.GeneralDetails.AutoRenewalPackage);
      this.changePackageButtonText = this.localizationService.Translate(changeTextTranslateKey);
    }

  }


  ngOnInit(): void {
    this.fitNavigationByLoginState();
  }

  ngOnDestroy() {
    this.couponValidationService.clear();
    this.onDestroy();

    if (this._loginSelect) {
      this._loginSelect.unsubscribe();
    }
  }

}
